export default {
  en: {
    dates: {
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
      sun: 'Sun',
      jan: 'January',
      feb: 'February',
      mar: 'March',
      apr: 'April',
      may: 'May',
      jun: 'June',
      jul: 'July',
      aug: 'August',
      sep: 'September',
      oct: 'October',
      nov: 'November',
      dec: 'December'
    }
  },
  nl: {
    dates: {
      mon: 'Ma',
      tue: 'Di',
      wed: 'Wo',
      thu: 'Do',
      fri: 'Vr',
      sat: 'Za',
      sun: 'Zo',
      jan: 'januari',
      feb: 'februari',
      mar: 'maart',
      apr: 'april',
      may: 'mei',
      jun: 'juni',
      jul: 'july',
      aug: 'augustus',
      sep: 'september',
      oct: 'october',
      nov: 'november',
      dec: 'december'
    }
  },
  fr: {
    dates: {
      dates: {
        mon: 'Lun',
        tue: 'Mar',
        wed: 'Mer',
        thu: 'Jeu',
        fri: 'Ven',
        sat: 'Sam',
        sun: 'Dim',
        jan: 'Janvier',
        feb: 'Février',
        mar: 'Mars',
        apr: 'Avril',
        may: 'Mai',
        jun: 'Juin',
        jul: 'Juillet',
        aug: 'Août',
        sep: 'Septembre',
        oct: 'Octobre',
        nov: 'Novembre',
        dec: 'Decembre'
      }
    }
  }
}
